import { type State } from "../../types"
// types
import { type ModuleType as Authorize } from "./_definitions"

export const authorizationSelector = (state: State): Authorize => state.authorization
